<template>
  <div>
    <div
      id="kpiDetailsModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <form>
            <div class="modal-header">
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                {{ output.label }}
              </h4>
            </div>
            <div class="modal-body">
              <div class="text-center">
                <ul
                  v-if="output.perZoneCategory"
                  class="nav nav-pills nav-pills-center"
                >
                  <template v-for="(zone, index) in graph.zoneCategories">
                    <li
                      :key="index"
                      :class="myChosenOutputZone == index ? 'active' : ''"
                      role="presentation"
                    >
                      <a @click="displayCurrentValues(index)">{{
                        zone.label
                      }}</a>
                    </li>
                  </template>
                </ul>
                <ChartComponent
                  :key="
                    currentStep + ',' + myChosenOutputZone + ',' + baselineName
                  "
                  :current-step="currentStep"
                  :data="graph.data"
                  :baseline="graph.baseline"
                  :baseline-name="baselineName"
                  :saved-run-name="savedRunName"
                  :legend="output.label"
                  :target="graph.target"
                  :format="graph.format"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartComponent from "../Chart.vue";
import data from "../../services/data";

import * as $ from "jquery";
import "bootstrap";

export default {
  components: {
    ChartComponent
  },
  props: {
    output: {
      type: Object,
      required: false,
      default: () => {}
    },
    chosenOutputZone: {
      type: Number,
      required: true
    },
    baselineOutput: {
      type: Object,
      required: false,
      default: () => {}
    },
    savedRunName: {
      type: String,
      required: false,
      default: null
    },
    baselineName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      currentStep: 0,
      graph: {
        data: [],
        zoneCategories: [],
        baseline: [],
        target: [],
        format: "0,0"
      },
      myChosenOutputZone: 0
    };
  },
  mounted() {
    this.graph.zoneCategories = data.zoneCategories;
    this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
    this.currentStep = this.currentRun.getCurrentStep();
  },
  created() {
    this.$root.$data.eventHub.$on("show-kpi-modal", this.displayModal);
  },
  methods: {
    displayModal: function() {
      this.displayCurrentValues(this.chosenOutputZone);
      $("#kpiDetailsModal").modal("show");
    },
    displayCurrentValues: function(changeZone) {
      this.currentRun = this.$root.$data.sharedStorage.getCurrentRun();
      const output = this.currentRun.getSavedOutput();
      if (!output) {
        return;
      }

      this.myChosenOutputZone = changeZone;
      this.graph.target = [];

      if (
        this.output.perZoneCategory &&
        output[this.output.name] &&
        this.baselineOutput[this.output.name]
      ) {
        const zone = data.zoneCategories[changeZone];
        const zoneName = zone ? zone.name : "";
        this.graph.data = output[this.output.name][zoneName];

        // Only try to display the baseline if there's one.
        // Otherwise we'll use the current value for the baseline,
        // but the current values' graph will be on top.
        const baseline =
          this.baselineOutput && this.baselineOutput[this.output.name]
            ? this.baselineOutput[this.output.name][zoneName]
            : null;
        if (baseline) {
          this.graph.baseline = baseline;
        } else {
          this.graph.baseline = output[this.output.name][zoneName];
        }
      } else {
        this.graph.data = output[this.output.name];

        // Only try to display the baseline if there's one
        // Otherwise we'll use the current value for the baseline,
        // but the current values' graph will be on top.
        const baseline =
          this.baselineOutput && this.baselineOutput
            ? this.baselineOutput[this.output.name]
            : null;
        if (baseline) {
          this.graph.baseline = baseline;
        } else {
          this.graph.baseline = output[this.output.name];
        }
      }

      this.graph.format = this.output.format;
    }
  }
};
</script>

<style lang="scss">
#kpiDetailsModal .modal-dialog {
  width: 800px;
}
.nav-pills-center {
  display: inline-block;
}
.modal-body,
.modal-body p,
.modal-body div {
  padding-bottom: 0;
  margin-bottom: 0;
}
</style>
